import { render } from "./FormatUnderline.vue?vue&type=template&id=a51aed6e"
import script from "./FormatUnderline.vue?vue&type=script&lang=js"
export * from "./FormatUnderline.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/FormatUnderline.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a51aed6e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a51aed6e', __exports__)) {
    api.reload('a51aed6e', __exports__)
  }
  
  module.hot.accept("./FormatUnderline.vue?vue&type=template&id=a51aed6e", () => {
    api.rerender('a51aed6e', render)
  })

}


export default __exports__